// These attributes are used to inspect and query draggable and droppable HTML
// elements.
export const DRAG_ID_ATTRIBUTE = 'data-dnd-drag-id'
export const DRAG_TYPE_ATTRIBUTE = 'data-dnd-drag-type'
export const DRAG_INDEX_ATTRIBUTE = 'data-dnd-drag-index'
export const DRAG_TRANSFORM_DISABLE = 'data-dnd-drag-transform-disable'
export const DROP_ID_ATTRIBUTE = 'data-dnd-drop-id'
export const DROP_TYPE_ATTRIBUTE = 'data-dnd-drop-type'
